export var classPrefix = 'mat-exreact';
export var prefixClassName = function (prefix, className) { return prefix + "-" + className; };
export var prefixExReact = function (className) { return prefixClassName(classPrefix, className); };
//# sourceMappingURL=components.js.map